import { useContext, useState } from 'react';

import { HeadquarterContext } from 'context/HeadquarterContext';
import { AuthContext } from 'context/AuthContext';

import { getAppOrderDirectDomain } from 'helpers/url';

import { ActionIcon, Badge, Button, Group, Indicator, Popover, Stack, Text } from '@mantine/core';
import DisableMiddleware from 'containers/Integrations/DisableMiddleware';


import { BADGE_VARIANTS } from 'constants/mantineVariants';

import { PBBStatus } from './PBBStatus';
import { InfoCircleIconSm } from '@chownow/pantry/icons';

export default function TabletStatus() {
  const { location } = useContext(HeadquarterContext);
  const { isInternalUser } = useContext(AuthContext);

  const {
    pos,
    middleware_integrator: middlewareIntegrator,
    order_auto_accept_configuration: orderAutoAccept,
    tablet,
  } = location;

  const isAutoAcceptEnabled = orderAutoAccept?.is_enabled;
  const isTabletOn = tablet?.seen_recently;

  const [opened, setOpened] = useState(false);

  const integrationsList = (() => {
    const list = [];
    const hasPos = pos?.name && pos?.is_enabled && pos?.is_authorized && pos?.is_active;

    if (hasPos) list.push(pos.name);
    if (middlewareIntegrator) list.push(middlewareIntegrator);

    return list;
  })();

  return (
    <Popover width={240} opened={opened} onChange={setOpened}>
      <Popover.Target>
        <ActionIcon
          onClick={() => setOpened(!opened)}
          pt="xs4"
          styles={{
            root: {
              backgroundColor: opened ? 'var(--surface-tertiary)' : undefined,
            },
          }}
        >
          <Indicator inline size={8} variant={isTabletOn ? 'active' : 'caution'} offset={-2}>
            <InfoCircleIconSm />
          </Indicator>
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown style={{ zIndex: 'calc(var(--mantine-z-index-modal) - 1)' }}>
        <Stack gap="md">
          {integrationsList.length > 0 && (
            <Group gap="xs2">
              {integrationsList.map(integration => (
                <Badge key={integration} variant={BADGE_VARIANTS.ink} size="xs">
                  {integration}
                </Badge>
              ))}
            </Group>
          )}
          <Group gap="xs2" align="flex-start">
            <Indicator
              label={isTabletOn ? 'on' : 'off'}
              variant={isTabletOn ? 'active' : 'caution'}
            />
            <Stack gap="xs3">
              <Text variant="sublabel-xs">Tablet is {isTabletOn ? 'on' : 'off'} </Text>
              {tablet?.version && <Text variant="sublabel-xs">Version {tablet?.version} </Text>}
              {tablet?.last_seen && (
                <Text variant="sublabel-xs">Last seen {tablet?.last_seen}</Text>
              )}
            </Stack>
          </Group>
          <Group gap="xs2">
            <Indicator
              label={isAutoAcceptEnabled ? 'on' : 'off'}
              variant={isAutoAcceptEnabled ? 'active' : 'neutral'}
            />
            <Text variant="sublabel-xs">
              Auto accept {isAutoAcceptEnabled ? 'enabled' : 'disabled'}
            </Text>
          </Group>
          <PBBStatus />
          <Button
            component="a"
            variant="outline"
            href={`${getAppOrderDirectDomain()}/${
              location.company_id
            }/locations/${location.id}?menu_status=preview`}
            target="_blank"
            fullWidth
            size="xs"
          >
            Preview Menu
          </Button>
          {middlewareIntegrator && isInternalUser && <DisableMiddleware />}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
